module.exports = __webpack_public_path__ + "static/media/back@2x.729d6273.png";